import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

function About() {
  return (
    <div>
      <Header />
      <section className="bg-lightGray min-h-screen">
        {/* Introduction */}
        <div className="container mx-auto px-4 py-16 sm:py-24 md:py-32 flex flex-col items-center text-center">
          <div className="max-w-4xl">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-6">
              A Little <span className="text-crimson">About Me</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              My name is <strong>Mohammad Rifal Ali Fahri</strong>, but you can
              simply call me <strong>Rifal</strong>. I'm a passionate{" "}
              <strong>Programmer and Developer</strong> capable of developing
              diverse projects, including{" "}
              <strong>websites, android applications</strong>, and even{" "}
              <strong>games</strong>!
            </p>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto mt-4">
              I recently graduated from a Vocational Highschool with a major in{" "}
              <strong>Software Engineering</strong> and I am currently pursuing
              my college degree in Informatics. I'm actively working towards
              graduating quickly to jump into more challenging opportunities.
              I'm really looking forward to future projects! Check out my work{" "}
              <Link
                to="/work"
                className="text-crimson font-semibold hover:underline transition duration-150"
              >
                right here
              </Link>
              .
            </p>
          </div>
        </div>

        {/* Education */}
        <div className="bg-white py-16 sm:py-20">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12">
              My <span className="text-crimson">Educational Journey</span>
            </h2>

            <div className="max-w-4xl mx-auto space-y-8">
              {/* Education Item 1: College */}
              <div className="border-l-4 border-crimson pl-6 py-2 shadow-md hover:shadow-lg transition duration-300 bg-gray-50 rounded-lg p-4">
                <h3 className="text-2xl font-semibold text-gray-900">
                  Bachelor's Degree in Informatics
                </h3>
                <p className="text-lg font-medium text-gray-700 mt-1">
                  National Development University "Veteran" of East Java
                </p>
                <p className="text-gray-500">
                  <strong>Currently Studying</strong>
                </p>
              </div>

              {/* Education Item 2: Highschool */}
              <div className="border-l-4 border-gray-300 pl-6 py-2 shadow-md hover:shadow-lg transition duration-300 bg-gray-50 rounded-lg p-4">
                <h3 className="text-2xl font-semibold text-gray-900">
                  Software Engineering Major
                </h3>
                <p className="text-lg font-medium text-gray-700 mt-1">
                  Public Vocational Highschool (SMKN) 2 Buduran Sidoarjo
                </p>
                <p className="text-gray-500">
                  <strong>Graduated 2025</strong> - Focus on practical software
                  development and coding fundamentals.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* --- Experience Section --- */}
        <div className="py-16 sm:py-20 bg-lightGray">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12">
              My <span className="text-crimson">Experiences</span>
            </h2>

            <div className="max-w-4xl mx-auto space-y-10">
              <div className="bg-white p-6 rounded-xl shadow-xl border-t-4 border-blue-500">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-1">
                  <p className="order-first sm:order-last text-sm font-semibold text-blue-500 mb-2 sm:mb-0 sm:text-right w-full sm:w-auto">
                    Okt 2024 - Mar 2025
                  </p>
                  <h3 className="order-last sm:order-first text-2xl font-bold text-gray-900 sm:pr-4">
                    Junior Android Developer
                  </h3>
                </div>
                <p className="text-lg font-medium text-gray-600 mb-3">
                  CV. IT Brain Indonesia [Field Practice]
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    Worked in a team environment to build core modules for a native Android application.
                  </li>
                  <li>
                    Utilized local databases to manage data persistence and ensured proper UI updates after data changes.
                  </li>
                  <li>
                    Gained practical experience navigating the complete application lifecycle up to the point of public deployment.
                  </li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-xl border-t-4 border-green-500">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-1">
                  <p className="order-first sm:order-last text-sm font-semibold text-green-500 mb-2 sm:mb-0 sm:text-right w-full sm:w-auto">
                    Jan 2024 - Mar 2025
                  </p>
                  <h3 className="order-last sm:order-first text-2xl font-bold text-gray-900 sm:pr-4">
                    Competencies Test XI & XII Grade
                  </h3>
                </div>
                <p className="text-lg font-medium text-gray-600 mb-3">
                  Public Vocational Highschool 2 Buduran Sidoarjo [PT. Maspion
                  IT & PT. Awak Media Indonesia]
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    Led a three-person team to successfully complete the final competency project (Web and Android).
                  </li>
                  <li>
                    Architected the full-stack solution, developing the web interface with React/Laravel and overseeing the Android client built with Kotlin/Laravel.
                  </li>
                  <li>
                    Implemented RESTful APIs to ensure reliable data integration and communication across both platforms.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* --- Achievements Section --- */}
        <div className="bg-white py-16 sm:py-20">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12">
              Achievements & <span className="text-crimson">Recognition</span>
            </h2>

            <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-8">
              <div className="w-full md:w-[calc(50%-1rem)] p-6 border-l-4 border-yellow-500 shadow-lg rounded-lg bg-yellow-50">
                <h3 className="text-xl font-bold text-gray-900">
                  1st Place: IT Software Solutions for Business
                </h3>
                <p className="text-gray-600 mt-1">
                  <strong>Awarded for:</strong> Developing an Android app with Kotlin and a desktop app with C# in a timed individual competition, showing strong programming and problem-solving skills.
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  Vocational Student Skills Competition (LKS) – Regency Level, Sidoarjo 2024
                </p>
              </div>

              <div className="w-full md:w-[calc(50%-1rem)] p-6 border-l-4 border-teal-500 shadow-lg rounded-lg bg-teal-50">
                <h3 className="text-xl font-bold text-gray-900">
                  2nd Place: IT Software Solutions for Business
                </h3>
                <p className="text-gray-600 mt-1">
                  <strong>Awarded for:</strong> Independently creating Android apps in Kotlin and desktop solutions in C#, demonstrating advanced technical ability at the provincial level.
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  Vocational Student Skills Competition (LKS) – Provincial Level, East Java 2024 (32nd Edition)
                </p>
              </div>

              <div className="w-full md:w-[calc(50%-1rem)] p-6 border-l-4 border-purple-500 shadow-lg rounded-lg bg-purple-50">
                <h3 className="text-xl font-bold text-gray-900">
                  4th Place: IT Software Solutions for Business
                </h3>
                <p className="text-gray-600 mt-1">
                  <strong>Awarded for:</strong> Achieving 4th place by building Android apps in Kotlin and desktop apps in C# with API integration, proving high-level competence at the national stage.
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  National Selection for the 14th WorldSkills Competition 2025, Indonesia 2024
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* --- Future Plan Section --- */}
        <div className="bg-lightGray py-16 sm:py-20">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-12">
              My <span className="text-crimson">Future Ambitions</span>
            </h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
                I have a deep enjoyment for technology and a strong desire for
                continuous growth. In the future, I plan to delve into
                specialized fields like <strong>Artificial Intelligence</strong>{" "}
                and <strong>Cyber Security</strong>.
              </p>
              <p className="text-lg sm:text-xl text-gray-700 leading-relaxed mt-4">
                Beyond professional development, I aspire to{" "}
                <strong>contribute to major public open-source projects</strong>
                . I am currently honing my skills to ensure that my contributions are meaningful and have a genuine impact on the community.
              </p>
              <p className="text-xl font-bold text-crimson mt-8">
                Alright, stay tuned for what's next in my journey!
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default About;
